import React, { Component, Fragment } from 'react';
import Axios from 'axios';
import env from '../../config/env';


class Land extends Component {

    state = {
        data: [],
        loading: false,
        adding: false,
        plotNumber: null,
        plotPrice: null,
        plotSize: null,
        community: '',
        theCommunity: [],
        update: false,
    }

    goBack = (e) => {
        this.setState({
            adding: false,
            update: false,
            plotNumber: null,
            plotPrice: null,
            plotSize: null
        })
        e.preventDefault();
    }

    go = (e) => {
        this.setState({
            adding: true
        })
        e.preventDefault();
    }

    AddModal = () => {
        return (
            <div style={modalHead} className='col-sm-8 col-md-6'>
                <div style={modalStyle}>
                    <h3> Add New Plot </h3><br /><br />
                    <form onSubmit={this.addItem}>
                        <input className='form-control' required type='number' name='plotNumber' value={this.state.plotNumber} onChange={this.handleChange} placeholder='Enter Plot Number' />
                        <input className='form-control' required type='number' name='plotSize' value={this.state.plotSize} onChange={this.handleChange} placeholder='Enter Plot Size' />
                        <input className='form-control' required type='number' name='plotPrice' value={this.state.plotPrice} onChange={this.handleChange} placeholder='Enter Plot Price' />
                        <select className='form-control' onChange={this.handleChange} name='community'>
                            <option value='disabled' defaultValue='selected'> Select Community </option>
                            {
                                this.state.theCommunity.map(item => {
                                    return (
                                        <option className='form-control' key={item._id} value={item._id}> {item.name}</option>
                                    )
                                })
                            }
                        </select>
                        <br />
                        <button type='submit' onClick={this.addItem} className='btn btn-info btn-raised btn-md'> + Add </button>
                        <button onClick={this.goBack} className='btn btn-warning btn-raised btn-md' style={{ float: 'right' }}> Back</button>
                    </form>
                </div>
            </div>
        )
    }

    UpdateModal = () => {
        return (
            <div style={modalHead} className='col-sm-8 col-md-6'>
                <div style={modalStyle}>
                    <h3> Update Plot </h3><br /><br />
                    <form onSubmit={() => this.updateItem(this.state._id)}>
                        <input className='form-control' required type='number' name='plotNumber' value={this.state.plotNumber} onChange={this.handleChange} placeholder='Plot Number' />
                        <input className='form-control' required type='number' name='plotSize' value={this.state.plotSize} onChange={this.handleChange} placeholder='Plot Size' />
                        <input className='form-control' required type='number' name='plotPrice' value={this.state.plotPrice} onChange={this.handleChange} placeholder='Plot Price' />
                        <select className='form-control' name='community' onChange={this.handleChange}>
                            <option value='disabled' defaultValue='selected'> Select Community </option>
                            {
                                this.state.theCommunity.map(item => {
                                    return (
                                        <option className='form-control' key={item._id} value={item._id}> {item.name}</option>
                                    )
                                })
                            }
                        </select>
                        <br />
                        <button type='submit' onClick={this.updateItem} className='btn btn-info btn-raised btn-md'> + Add </button>
                        <button onClick={this.goBack} className='btn btn-warning btn-raised btn-md' style={{ float: 'right' }}> Back</button>
                    </form>
                </div>
            </div >
        )
    }

    addItem = (e) => {
        const url = env.appPath + 'plots/create';
        const { plotNumber, plotPrice, plotSize, community } = this.state;
        const data = { plotNumber, plotPrice, plotSize, community }
        console.log(data);
        Axios.post(url, data)
            .then((response) => {
                alert(response.data.status);
            })
        e.preventDefault();
        this.setState({
            adding: false,
            community: '',
            plotNumber: null,
            plotPrice: null,
            plotSize: null,
            update: false,
        })
    }

    updateItem = (e) => {
        const url = env.appPath + `plots/update/${this.state.id}`;
        const { plotNumber, plotPrice, plotSize, community } = this.state;
        const data = { plotNumber, plotPrice, plotSize, community }
        Axios.put(url, data)
            .then((response) => {
                alert(response.data.status);
            })
        e.preventDefault();
        this.setState({
            adding: false,
            update: false,
            community: '',
            plotNumber: null,
            plotPrice: null,
            plotSize: null,
        })
    }

    EditItem = (props) => {
        this.setState(props);
        this.setState({ id: props._id, update: true })
        // console.log(props, this.state.id);
    }


    DeleteItem = (id) => {
        // console.log('i am here')
        const url = env.appPath + `plots/delete/${id}`;
        Axios.delete(url)
            .then((res) => {
                alert(res.data.status);
            })
    }

    async componentDidMount() {
        const url = env.appPath + 'plots/';
        await Axios.get(url)
            .then((res) => {
                this.setState({
                    data: res.data.data
                });
                console.log('response from land on componentMount is: ', res.data.data);
            }
            )
        await Axios.get(env.appPath + 'communities/')
            .then(res => {
                this.setState({
                    theCommunity: res.data.data
                });
                // console.log('here is the state: ', this.state.theCommunity)
            })
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    componentDidUpdate() {
        const url = env.appPath + 'plots/'
        Axios.get(url)
            .then((res) => {
                this.setState({
                    data: res.data.data
                });
                // console.log('response from land is: ', res.data.data);
            }
            )
    }

    render() {
        const { data } = this.state;
        return (
            <Fragment>
                <section id="content">
                    <div className="page full-pagewidth-layout">
                        <div className="bg-light lter b-b wrapper-md mb-10">
                            <div className="row">
                                <div className="col-sm-6 col-xs-12">
                                    <h3 className="font-thin h3 m-0">Land Management Software</h3>
                                    <small className="text-muted">Welcome to Private Estate's Management Solution</small>
                                </div>
                                <button className='btn btn-raised btn-info' style={{ float: 'right', right: 15 }} onClick={this.go}> + Add new </button>
                            </div>
                        </div>
                        <label><h4>Land for Sale </h4></label>
                        <div className="row clearfix">

                            {
                                data ?
                                    data.map((item) => {
                                        return <Fragment key={item._id}>
                                            <div className="col-md-3 col-sm-6  col-xs-12">
                                                <div className="boxs project_widget">
                                                    <div className="pw_content">
                                                        <div className="pw_header">
                                                            <span style={{ float: 'right', position: 'relative' }}>
                                                                <div className="dropdown">
                                                                    <span className="btn btn-simple dropdown-toggle" data-toggle="dropdown">
                                                                        <i className="fa fa-ellipsis-v"></i>
                                                                    </span>
                                                                    <ul className="dropdown-menu pull-right" style={{ padding: '10%' }}>
                                                                        <li style={pointer} onClick={() => this.EditItem(item)}>
                                                                            <i className='fa fa-pencil' /> &nbsp;Edit
                                                                            </li>
                                                                        <li className="divider"></li>
                                                                        <li style={pointer} onClick={() => this.DeleteItem(item._id)} >
                                                                            <i className='fa fa-trash' /> &nbsp;Delete
                                                                            </li>
                                                                    </ul>
                                                                </div>
                                                            </span>
                                                            <h6>Plot Number: {item.plotNumber ? item.plotNumber : 'unknown'} </h6>
                                                            <small className="text-muted">Plot size | <span className='text-primary'>{item.plotSize ? item.plotSize : 'unknown'}</span></small>
                                                        </div>
                                                        <div className="pw_meta">
                                                            <span># {item.plotPrice ? item. plotPrice : 'unknown'} Million</span>
                                                            {/* <small className="text-muted">Community: {item.community}</small> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Fragment>
                                    })
                                    :
                                    <h3> Loading ...</h3>
                            }
                        </div>

                        {
                            this.state.adding ?
                                this.AddModal() :
                                this.state.update ?
                                    this.UpdateModal() :
                                    null
                        }
                    </div>
                </section>
            </Fragment >
        )
    }
}

export default Land;


const modalHead = {
    backgroundColor: 'rgba(0,0,0,0.03)',
    height: '90vh',
    width: '100%',
    zIndex: 20,
    position: 'absolute',
    left: 0,
    top: '-10vh',
}

const modalStyle = {
    left: '25%',
    width: '40%',
    zIndex: 19,
    backgroundColor: 'white',
    position: 'absolute',
    padding: '3%',
    top: 200,
    margin: 'auto',
    boxShadow: '1px 0px 7px 1px rgba(0,0,0,0.4)'
}

const pointer = {
    cursor: 'pointer'
}


// WEBPACK FOOTER //
// ./src/Components/Land/index.js